/* Merme Wishlist — Phase 1 (localStorage). Storage is isolated behind the
   MermeWishlist object so a server backend can be swapped in later without
   touching any UI. Stores an array of product handles. */
(function () {
  var KEY = 'merme_wishlist';

  var MermeWishlist = window.MermeWishlist = {
    list: function () {
      try {
        var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        // tolerate legacy entries that were objects {handle:...}
        return raw.map(function (x) { return typeof x === 'string' ? x : (x && x.handle); }).filter(Boolean);
      } catch (e) { return []; }
    },
    has: function (handle) { return this.list().indexOf(handle) !== -1; },
    _save: function (arr) {
      localStorage.setItem(KEY, JSON.stringify(arr));
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: arr } }));
    },
    add: function (handle) { var a = this.list(); if (a.indexOf(handle) === -1) { a.push(handle); this._save(a); } },
    remove: function (handle) { var a = this.list().filter(function (h) { return h !== handle; }); this._save(a); },
    toggle: function (handle) { this.has(handle) ? this.remove(handle) : this.add(handle); return this.has(handle); },
    count: function () { return this.list().length; }
  };

  /* ---- Reflect state on all heart buttons + the header badge ---- */
  function paintButtons() {
    var saved = MermeWishlist.list();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = saved.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function paintBadge() {
    var n = MermeWishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  function paintAll() { paintButtons(); paintBadge(); }
  MermeWishlist.paint = paintAll; // let AJAX grid swaps (shop filters) repaint saved state

  /* ---- Click handling (delegated so it covers AJAX-injected cards) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    MermeWishlist.toggle(handle);
  });
  document.addEventListener('wishlist:change', paintAll);
  // also sync across tabs
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintAll(); });

  /* ---- Wishlist page renderer (fetch-on-load) ---- */
  function currency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }
  function fmt(cents) {
    // match the cart's shop money format ("Rs. 2,250.00") so both lists read the same
    if (currency() === 'INR') return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency() }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function cardHTML(p) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=800';
    var price = p.price != null ? '<div class="mwl-price">' + fmt(p.price) + '</div>' : '';
    return '' +
      '<div class="mwl-item" data-mwl-item="' + p.handle + '">' +
        '<button type="button" class="mwl-heart mwl-heart--card is-active" data-wishlist-toggle data-handle="' + p.handle + '" aria-pressed="true" aria-label="Remove from wishlist">' + heartSVG() + '</button>' +
        '<a class="mwl-card" href="' + p.url + '">' +
          '<div class="mwl-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<h3 class="mwl-title">' + (p.title || '') + '</h3>' + price +
        '</a>' +
      '</div>';
  }
  function heartSVG() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  function renderWishlistPage(root) {
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var loading = root.querySelector('[data-wishlist-loading]');
    function render() {
      var handles = MermeWishlist.list();
      if (loading) loading.hidden = true;
      if (!handles.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var saved = MermeWishlist.list(); // re-read in case it changed
        grid.innerHTML = products
          .filter(function (p) { return p && saved.indexOf(p.handle) !== -1; })
          .map(cardHTML).join('');
        if (!grid.children.length && empty) empty.hidden = false;
      });
    }
    render();
    // re-render when an item is removed from the page
    document.addEventListener('wishlist:change', function () {
      // remove just the toggled card without a full refetch, then show empty if needed
      MermeWishlist.list();
      grid.querySelectorAll('[data-mwl-item]').forEach(function (el) {
        if (!MermeWishlist.has(el.getAttribute('data-mwl-item'))) el.remove();
      });
      if (!grid.children.length) { if (empty) empty.hidden = false; }
    });
  }

  /* ---- Wishlist carousel inside the cart drawer ---- */
  function cartCardHTML(p) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
    var price = p.price != null ? '<div class="mcw-price">' + fmt(p.price) + '</div>' : '';
    var vid = (p.variants && p.variants[0] && p.variants[0].id) || '';
    return '' +
      '<div class="mcw-item" data-mcw-item="' + p.handle + '">' +
        '<a class="mcw-media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a class="mcw-title" href="' + p.url + '">' + (p.title || '') + '</a>' + price +
        '<button type="button" class="mcw-add" data-mcw-add data-id="' + vid + '" aria-label="Add ' + (p.title || 'item').replace(/"/g, '&quot;') + ' to cart"><span>+ Add</span></button>' +
        '<button type="button" class="mcw-remove" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Remove from wishlist">✕<span class="mcw-remove__txt"> Remove</span></button>' +
      '</div>';
  }

  function renderCartWishlist() {
    var box = document.querySelector('[data-cart-wishlist]');
    if (!box) return;
    var track = box.querySelector('[data-cart-wishlist-track]');
    var countEls = box.querySelectorAll('[data-cart-wishlist-count]');
    // hide wishlist items that are already in the cart (no point offering "Add")
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return i.handle; });
        var handles = MermeWishlist.list().filter(function (h) { return inCart.indexOf(h) === -1; });
        countEls.forEach(function (el) { el.textContent = handles.length; });
        if (!handles.length) { box.hidden = true; if (track) track.innerHTML = ''; return; }
        box.hidden = false;
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          var keep = MermeWishlist.list();
          track.innerHTML = products.filter(function (p) { return p && keep.indexOf(p.handle) !== -1 && inCart.indexOf(p.handle) === -1; }).map(cartCardHTML).join('');
          if (!track.children.length) box.hidden = true;
        });
      });
  }

  /* Add-to-cart from the cart wishlist carousel */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-mcw-add]');
    if (!add) return;
    var id = add.getAttribute('data-id');
    if (!id) return;
    add.disabled = true;
    var d = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (d && d.renderContents) { d.renderContents(res); d.classList.remove('is-empty'); var it = d.querySelector('cart-drawer-items'); if (it) it.classList.remove('is-empty'); }
        document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: MermeWishlist.list() } }));
      }).catch(function () { add.disabled = false; });
  });

  /* ---- Standalone wishlist drawer (slide-in like the cart) ---- */
  function wlDrawer() { return document.querySelector('[data-wishlist-drawer]'); }
  function openWlDrawer() {
    var d = wlDrawer(); if (!d) return;
    renderWlDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bb-no-scroll');
    document.body.style.overflow = 'hidden';
  }
  function closeWlDrawer() {
    var d = wlDrawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bb-no-scroll');
    document.body.style.overflow = '';
  }
  function renderWlDrawer() {
    var d = wlDrawer(); if (!d) return;
    var grid = d.querySelector('[data-wishlist-drawer-grid]');
    var empty = d.querySelector('[data-wishlist-drawer-empty]');
    var loading = d.querySelector('[data-wishlist-drawer-loading]');
    var handles = MermeWishlist.list();
    if (!handles.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; if (loading) loading.hidden = true; return; }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      if (loading) loading.hidden = true;
      var saved = MermeWishlist.list();
      grid.innerHTML = products.filter(function (p) { return p && saved.indexOf(p.handle) !== -1; }).map(cartCardHTML).join('');
      if (!grid.children.length && empty) empty.hidden = false;
    });
  }
  // header wishlist icon opens the drawer instead of navigating to the page
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="/pages/wishlist"], [data-wishlist-open]');
    if (!link) return;
    if (!wlDrawer()) return; // no drawer → let it navigate to the page
    e.preventDefault();
    openWlDrawer();
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-mwd-close]')) closeWlDrawer(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wlDrawer() && wlDrawer().classList.contains('is-open')) closeWlDrawer();
  });

  function init() {
    paintAll();
    renderCartWishlist();
    var page = document.querySelector('[data-wishlist-page]');
    if (page) renderWishlistPage(page);
    // re-populate the cart wishlist whenever the drawer re-renders (renderContents wipes it)
    var cart = document.querySelector('cart-drawer');
    if (cart && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        var box = cart.querySelector('[data-cart-wishlist]');
        var track = box && box.querySelector('[data-cart-wishlist-track]');
        if (box && track && track.children.length === 0 && MermeWishlist.list().length) {
          clearTimeout(t); t = setTimeout(renderCartWishlist, 60);
        }
      }).observe(cart, { childList: true, subtree: true });
    }
  }
  document.addEventListener('wishlist:change', function () {
    renderCartWishlist();
    var d = wlDrawer();
    if (d && d.classList.contains('is-open')) renderWlDrawer();
  });
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', paintAll);
})();
